import styled from 'styled-components';
import {
  defaultBorderRadius,
  defaultBorderRadiusValue,
  defaultShadow,
  modalOverlayZIndex,
} from '../../styles/global';

interface ModalStylesProps {
  isLoading?: boolean;
  maximized: boolean;
}

export const ModalContainer = styled.div`
  background: ${(p) => p.theme.colors.background}90;
  backdrop-filter: blur(2px);

  width: 100%;
  height: 100%;

  position: fixed;
  z-index: ${modalOverlayZIndex};
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
`;

export const ModalContent = styled.div<ModalStylesProps>`
  position: relative;
  background: ${(p) => p.theme.colors.background};

  display: flex;
  align-items: center;
  flex-direction: column;

  ${defaultShadow}
  ${defaultBorderRadius}
  box-sizing: border-box;

  ${(p) => p.isLoading && '> * { opacity: 0.5; }'}

  max-height: 80vh;
  max-width: 80vw;
  min-width: 300px;

  @media (max-width: 936px) {
    max-width: 100vw;
  }
  @media (max-height: 580px) {
    max-height: 100vh;
  }

  /* Maximized */
  ${(p) => p.maximized && `
    position: fixed;
    left: 0px;
    top: 0px;

    min-width: 100vw;
    min-height: 100vh;
    max-height: 100vh;
    max-height: 100vh;
  `}
`;

export const ModalHeader = styled.div`
  background: ${(p) => p.theme.colors.surface};
  color: ${(p) => p.theme.colors.onSurface};

  position: absolute;
  top: 0;
  z-index: 500;

  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 4rem;
  padding: 1rem;
  box-sizing: border-box;

  border-top-left-radius: ${defaultBorderRadiusValue};
  border-top-right-radius: ${defaultBorderRadiusValue};

  #modal-title {
    font-weight: bold;
    font-size: 1.3rem;
  }

  #modal-header-icons {
    display: flex;
    align-items: center;

    > * {
      margin-left: 0.5rem;
    }
  }

  border-bottom: 1px solid ${(p) => p.theme.colors.onBackground}10;
`;

export const ModalBody = styled.div`
  scrollbar-width: thin;
  width: 100%;
  max-width: 100%;

  padding-top: 4rem;
  padding-bottom: 4rem;

  overflow: auto;
`;

export const ModalFooter = styled.div`
  background: ${(p) => p.theme.colors.surface};
  color: ${(p) => p.theme.colors.onSurface};

  position: absolute;
  bottom: 0;

  width: 100%;
  height: 4rem;

  padding: 0.5rem;
  border-top: 1px solid ${(p) => p.theme.colors.onBackground}10;
  box-sizing: border-box;

  border-bottom-left-radius: ${defaultBorderRadiusValue};
  border-bottom-right-radius: ${defaultBorderRadiusValue};

  .buttons-footer {
    flex: 1;
    display: flex;
    justify-content: end;
  }
`;

export default ModalContainer;
